import { render } from "./Topbar.vue?vue&type=template&id=e3fabc1e&scoped=true"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"

import "./Topbar.vue?vue&type=style&index=0&id=e3fabc1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fabc1e"]])

export default __exports__